"use strict";var _interopRequireDefault = require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;var _message = _interopRequireDefault(require("element-ui/lib/theme-chalk/message.css"));require("element-ui/lib/theme-chalk/base.css");var _message2 = _interopRequireDefault(require("element-ui/lib/message"));var _axios = _interopRequireDefault(require("axios"));

var _store = _interopRequireDefault(require("@/store"));
var _auth = require("@/utils/auth");

// create an axios instance
var service = _axios.default.create({
  baseURL: "",
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 500000 // request timeout
});

// request interceptor
service.interceptors.request.use(
function (config) {
  // do something before request is sent
  var token = (0, _auth.getToken)();
  if (_store.default.getters.token) {
    // let each request carry token
    // ['X-Token'] is a custom headers key
    // please modify it according to the actual situation
    config.headers["X-Token"] = token;
  }
  return config;
},
function (error) {
  // do something with request error
  console.log(error); // for debug
  return Promise.reject(error);
});


// response interceptor
service.interceptors.response.use(
/**
                                    * If you want to get http information such as headers or status
                                    * Please return  response => response
                                    */

/**
                                        * Determine the request status by custom code
                                        * Here is just an example
                                        * You can also judge the status by HTTP Status Code
                                        */
function (response) {
  // console.log('response=====>',JSON.stringify(response))
  var res = response.data;
  // console.log('res=====>',res)
  // if the custom code is not 0, it is judged as an error.
  if (res.errCode !== "0") {
    (0, _message2.default)({
      message: res.errMsg || "Error",
      type: "error",
      duration: 5 * 1000 });


    setTimeout(function () {
      if (res.errMsg == "用户未登录！") {
        _store.default.dispatch("user/resetToken").then(function () {
          location.reload();
        });
      }

      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      if (res.errCode === "E1001") {
        _store.default.dispatch("user/resetToken").then(function () {
          location.reload();
        });
      }
    }, 5 * 1000);
    return Promise.reject(new Error(res.errMsg || "Error"));
  } else {
    return res;
  }
},
function (error) {
  console.log("err=====>" + error); // for debug

  // 如果报错为Network Error就删除token，否则无法跳转到login页面

  if (error == "Error: Network Error") {
    // removeToken()
    console.log("store=====>", _store.default);
    console.log("window.location.href====>", window.location.href);
    // // 待验证
    // this.$router.replace({
    //   path: '/redirect' + this.$router.fullPath
    // })
    _store.default.dispatch("user/resetToken").then(function () {
      location.reload();
    });
    // return Promise.reject(error)
    // window.location.href = window.location.href + 'login'
  }
  _Message({
    message: error.message,
    type: "error",
    duration: 5 * 1000 });

  // router.resolve({ name: 'login', path: '/login' })
  return Promise.reject(error);
});var _default =


service;exports.default = _default;